import type {z} from "zod/v4-mini"
import type {Json} from "@cm/graph-v3"
import {jsonSchema} from "@cm/graph-v3"
import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"

export const jsonLikeMarker = Symbol("JsonLike")

export interface JsonLikeNode extends FundamentalLikeNode<Json | null> {
    readonly [jsonLikeMarker]: true
}

export const isJsonValue = (x: unknown): x is Json => jsonSchema.safeParse(x).success

export const jsonMarker = createFundamentalMarker<JsonLikeNode, Json>(jsonLikeMarker, {rawSchema: jsonSchema, acceptsRaw: isJsonValue})
export const {isLikeNode: isJsonLikeNode, isLikeNodeClass: isJsonLikeNodeClass, likeNode: jsonLikeNode, isLike: isJsonLike, like: jsonLike} = jsonMarker
export type JsonLike = z.infer<typeof jsonLike>
